module.exports = __webpack_public_path__ + "media/images/icons/up_arrow-68ae9813acbab3fb84285ec27979aa9b.png";